import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/gift_code/tracoImg1.png'
import _imports_1 from '@/assets/sideNavbar/18+_cai.png'
import _imports_2 from '@/assets/sideNavbar/facebook_cai.png'
import _imports_3 from '@/assets/sideNavbar/Telegram_cai.png'


const _hoisted_1 = { class: "cuponContainer" }
const _hoisted_2 = { class: "gift-banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "middleCard" }
const _hoisted_5 = { class: "top-text" }
const _hoisted_6 = {
  class: "top-text",
  style: {"color":"#ffa4d170","font-size":"12px","top":"16.5vh","left":"28%"}
}
const _hoisted_7 = { class: "exchange-btn" }
const _hoisted_8 = {
  key: 1,
  class: "exchange-btn-disabled",
  disabled: ""
}
const _hoisted_9 = { class: "shareIconContainer" }
const _hoisted_10 = {
  key: 0,
  class: "bottom_text"
}
const _hoisted_11 = { class: "title" }

import { GiftCodeData } from '@/view/giftCode/giftCodeView';
import { watch, ref } from 'vue';
import CustomHeader from '../components/common/customHeader.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'giftCodeView',
  props: {
    dataSet: {}
  },
  emits: ['pasteCode', 'goToShare', 'claimSubmit'],
  setup(__props: any, { emit: __emit }) {


const emits = __emit

const props = __props

const couponCode = ref(props.dataSet.couponCode)

watch(
  () => props.dataSet.couponCode,
  val => (couponCode.value = val)
);

const pasteCode = async () => {
  try {
    const text = await navigator.clipboard.readText();
    if (!text) return;

    couponCode.value = text;
    emits('pasteCode', text); 
  } catch (err) {
    console.error('Paste failed', err);
  }
};
const claimSubmit = () => {
    console.log("Cupon code", couponCode.value)
    emits('claimSubmit', couponCode.value)
}
const goToShare = async () => {
    emits("goToShare")
}


return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('giftCode.exchangeReward')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _ctx.dataSet.bannerIcon,
          alt: "banner",
          class: "banner-img"
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_van_row, { class: "middle-row" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, { span: "24" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('giftCode.pasteText')) + ":", 1),
                  _createVNode(_component_van_row, { class: "couponInput" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, { span: "17" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_van_field, {
                            class: "pasteInput",
                            placeholder: _ctx.$t('giftCode.insertPaste'),
                            modelValue: couponCode.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((couponCode).value = $event))
                          }, null, 8, ["placeholder", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_col, {
                        span: "6",
                        style: {"display":"flex","justify-content":"flex-end","align-items":"center"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: "copy-btn",
                            onClick: pasteCode
                          }, _toDisplayString(_ctx.$t('common.colar')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('giftCode.pasteInstructions')), 1),
                  _createElementVNode("div", _hoisted_7, [
                    (couponCode.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "exchange-btn-active",
                          onClick: claimSubmit
                        }, _toDisplayString(_ctx.$t('common.exchange')), 1))
                      : (_openBlock(), _createElementBlock("button", _hoisted_8, _toDisplayString(_ctx.$t('common.exchange')), 1))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_van_row, { class: "shareCard" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "4",
              class: "titleImage"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "banner"
                }, null, -1)
              ])),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "20",
              class: "titleText",
              style: {"display":"flex","align-items":"center"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('giftCode.mediaTitle')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, { span: "24" }, {
              default: _withCtx(() => [
                _createElementVNode("div", { class: "mediaIcons" }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "banner",
                    class: "media-img",
                    onClick: goToShare
                  }),
                  _createElementVNode("img", {
                    src: _imports_2,
                    alt: "banner",
                    class: "media-img",
                    onClick: goToShare
                  }),
                  _createElementVNode("img", {
                    src: _imports_3,
                    alt: "banner",
                    class: "media-img",
                    onClick: goToShare
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      (_ctx.dataSet.activityInfo.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('common.activityTitle')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.activityInfo, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "line_text",
                key: index
              }, _toDisplayString(item), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})